// The set pieces: a whole station of a place drawn as one thing (a bar with its taps and bottles, a tube
// platform with its train), the way Lagos Life builds its places. The names live here so the content can name
// them; the game draws each one (packages/game/src/venue/pieces). `label` is what the admin sees.
export const SET_PIECE_LABELS = {
  // work and study
  reception: 'Reception desk',
  deskpod: 'Desks with screens',
  meetingroom: 'Glass meeting room',
  lifts: 'Lifts',
  cooler: 'Water cooler',
  loos: 'Toilet doors',
  lectern: 'Lectern',
  seatrow: 'Row of seats',
  bookcases: 'Bookcases',
  piano: 'Piano',
  // food and drink
  bar: 'Bar with taps and bottles',
  booth: 'Booth seats',
  coffeebar: 'Coffee counter',
  tableset: 'Table and chairs',
  kiosk: 'Kiosk',
  foodtruck: 'Food truck',
  fireplace: 'Fireplace',
  // fun
  dartboard: 'Dartboard',
  pooltable: 'Pool table',
  concertstage: 'Concert stage',
  lanes: 'Bowling lanes',
  bigscreen: 'Big screen',
  deckchairs: 'Deckchairs',
  dancefloor: 'Dance floor',
  // shops and markets
  shopfront: 'Shop front',
  marketstall: 'Market stall',
  fishstall: 'Fish stall',
  scales: 'Market scales',
  expobooth: 'Exhibition stand',
  billboard: 'Billboard',
  // transport
  platform: 'Tube platform and train',
  railplatform: 'Railway platform and train',
  gates: 'Ticket gates',
  escalator: 'Escalator',
  roundel: 'Station sign',
  shelter: 'Shelter',
  checkin: 'Check-in desks',
  scanner: 'Security scanner',
  plane: 'Plane',
  cablestation: 'Cable car station',
  gondola: 'Cable car',
  pylon: 'Cable car tower',
  clipper: 'River boat',
  pierdeck: 'Pier deck',
  forklift: 'Forklift',
  showcar: 'Show car',
  // culture
  pews: 'Pews',
  altar: 'Altar',
  pulpit: 'Pulpit',
  organ: 'Organ',
  candles: 'Candle stand',
  stainedglass: 'Stained-glass window',
  exhibit: 'Museum case',
  shipmodel: 'Model ship',
  barrels: 'Barrels',
  infoboard: 'Board',
  ropes: 'Rope barrier',
  ship: 'Tall ship',
  telescope: 'Telescope',
  meridian: 'Meridian line',
  planetarium: 'Planetarium dome',
  statue: 'Statue',
  // voting (Gov: City Hall's polling station)
  votingbooth: 'Voting booths',
  ballotbox: 'Ballot box',
  dog: 'Dog',
  // health and sport
  consult: 'Consulting booth',
  pharmacy: 'Pharmacy',
  weightbench: 'Weight bench',
  yogamats: 'Yoga mats',
  showers: 'Showers',
  mirror: 'Mirror wall',
  // outdoors
  river: 'River',
  railings: 'Railings',
  pond: 'Pond',
  fountain: 'Fountain',
  lattice: 'Timber roof',
  arch: 'Entrance arch',
  tunneldome: 'Foot tunnel dome',
  pen: 'Animal pen',
  haybales: 'Hay bales',
  barn: 'Barn',
  tractor: 'Tractor',
  deer: 'Deer',
  picnicmat: 'Picnic blanket',
  lamppost: 'Lamp post',
  barrierpier: 'Thames Barrier pier',
  // industry and land
  tanks: 'Tanks',
  conveyor: 'Conveyor',
  pallets: 'Pallets of sacks',
  controlpanel: 'Control panel',
  plot: 'Plot of land',
  portacabin: 'Site office',
} as const;
export type SetPiece = keyof typeof SET_PIECE_LABELS;
export const SET_PIECES = Object.keys(SET_PIECE_LABELS) as [SetPiece, ...SetPiece[]];
